"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
require("./App.css");
var solana_headless_react_1 = require("@hermis/solana-headless-react");
var solana_headless_core_1 = require("@hermis/solana-headless-core");
var errors_1 = require("@hermis/errors");
var kit_1 = require("@solana/kit");
// Import the custom components we created
var Navigation_1 = require("./components/Navigation");
var WalletModal_1 = require("./components/WalletModal");
var TransactionCard_1 = require("./components/TransactionCard");
var TokenBalances_1 = require("./components/TokenBalances");
var NFTGallery_1 = require("./components/NFTGallery");
var NetworkSelector_1 = require("./components/NetworkSelector");
// import { TransactionMethodsDemo } from './components/TransactionMethodsDemo'
// import { ArchitectureComparison } from './components/ArchitectureComparison'
// import { UnifiedAPIDemo } from './components/UnifiedAPIDemo'
var WalletContextProvider_1 = require("./context/WalletContextProvider");
var KitDemo_1 = require("./pages/KitDemo");
var DocsValidation_1 = require("./pages/DocsValidation");
var KitRpcContext_1 = require("./context/KitRpcContext");
var kit_2 = require("@solana/kit");
var WalletItem = function (_a) {
    var name = _a.name, icon = _a.icon, readyState = _a.readyState, index = _a.index, isSelected = _a.isSelected, disabled = _a.disabled, onClick = _a.onClick;
    var getReadyStateLabel = function (readyState) {
        switch (readyState) {
            case solana_headless_core_1.WalletReadyState.Installed:
                return 'Installed';
            case solana_headless_core_1.WalletReadyState.Loadable:
                return 'Loadable';
            case solana_headless_core_1.WalletReadyState.NotDetected:
                return 'Not Detected';
            case solana_headless_core_1.WalletReadyState.Unsupported:
                return 'Not Supported';
            default:
                return 'Unknown';
        }
    };
    var statusClass = readyState === solana_headless_core_1.WalletReadyState.Installed ? 'installed' :
        readyState === solana_headless_core_1.WalletReadyState.Unsupported ? 'unsupported' :
            readyState === solana_headless_core_1.WalletReadyState.NotDetected ? 'not-detected' : '';
    return ((0, jsx_runtime_1.jsxs)("div", { className: "wallet-item ".concat(disabled ? 'disabled' : ''), style: {
            border: isSelected ? '2px solid #9945FF' : '1px solid #eee',
            backgroundColor: isSelected ? '#f0e6ff' : '',
            opacity: disabled ? 0.6 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer'
        }, onClick: disabled ? undefined : onClick, title: disabled ? "".concat(name, " cannot be selected (").concat(getReadyStateLabel(readyState), ")") : undefined, children: [(0, jsx_runtime_1.jsxs)("span", { className: "wallet-index", children: [index, "."] }), (0, jsx_runtime_1.jsx)("img", { src: icon, alt: "".concat(name, " icon"), onError: function (e) {
                    var target = e.target;
                    target.src = 'https://raw.githubusercontent.com/solana-labs/wallet-adapter/master/packages/wallets/icons/generic.svg';
                } }), (0, jsx_runtime_1.jsx)("div", { children: name }), (0, jsx_runtime_1.jsx)("div", { className: "status ".concat(statusClass), children: getReadyStateLabel(readyState) })] }));
};
// Create Kit RPC instances
var kitRpc = (0, kit_2.createSolanaRpc)((0, kit_2.devnet)('https://api.devnet.solana.com'));
var kitRpcSubscriptions = (0, kit_2.createSolanaRpcSubscriptions)((0, kit_2.devnet)('wss://api.devnet.solana.com'));
function App() {
    // Main JSX render
    return ((0, jsx_runtime_1.jsxs)(KitRpcContext_1.KitRpcContext.Provider, { value: { rpc: kitRpc, rpcSubscriptions: kitRpcSubscriptions }, children: [(0, jsx_runtime_1.jsx)(Navigation_1.Navigation, {}), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/", element: (0, jsx_runtime_1.jsx)(HomePage, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/kit", element: (0, jsx_runtime_1.jsx)(KitDemo_1.KitDemo, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/docs-validation", element: (0, jsx_runtime_1.jsx)(DocsValidation_1.default, {}) })] })] }));
}
// HomePage component - extracted from the original App return
function HomePage() {
    var _this = this;
    // Network context
    var _a = (0, WalletContextProvider_1.useNetwork)(), currentNetwork = _a.currentNetwork, changeNetwork = _a.changeNetwork, isChangingNetwork = _a.isChangingNetwork;
    // React hooks from the headless SDK
    var _b = (0, solana_headless_react_1.useWallet)(), wallet = _b.wallet, wallets = _b.wallets, publicKey = _b.publicKey, connecting = _b.connecting, connected = _b.connected, select = _b.select, connect = _b.connect, disconnect = _b.disconnect, signIn = _b.signIn, signMessage = _b.signMessage;
    var dualConnection = (0, solana_headless_react_1.useConnection)().connection;
    // Cast to legacy Connection for existing code compatibility
    var connection = dualConnection;
    var _c = (0, solana_headless_react_1.useWalletAdapters)(), installed = _c.installed, loadable = _c.loadable, notDetected = _c.notDetected;
    var balance = (0, solana_headless_react_1.useSolanaBalance)(publicKey);
    // Local component state
    var _d = (0, react_1.useState)(null), clickedWalletName = _d[0], setClickedWalletName = _d[1];
    var _e = (0, react_1.useState)([]), eventLogs = _e[0], setEventLogs = _e[1];
    var eventLogRef = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(false), isFetchingBalance = _f[0], setIsFetchingBalance = _f[1];
    var previousPublicKeyRef = (0, react_1.useRef)(null);
    var isMobile = (0, solana_headless_react_1.getIsMobile)(wallets.map(function (w) { return w.adapter; }));
    // Add log entry
    var addLogEntry = (0, react_1.useCallback)(function (message, type) {
        if (type === void 0) { type = 'info'; }
        setEventLogs(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{
                message: message,
                type: type,
                timestamp: new Date()
            }], false); });
    }, []);
    // Clear logs
    var clearLogs = function () {
        setEventLogs([]);
        addLogEntry('Log cleared', 'info');
    };
    // Auto-scroll log to bottom when new entries added
    (0, react_1.useEffect)(function () {
        if (eventLogRef.current) {
            eventLogRef.current.scrollTop = eventLogRef.current.scrollHeight;
        }
    }, [eventLogs]);
    // Log when component mounts
    (0, react_1.useEffect)(function () {
        addLogEntry('Initializing wallet integration...', 'info');
        addLogEntry("Device environment: ".concat(isMobile ? 'Mobile' : 'Desktop'), 'info');
        addLogEntry("Found ".concat(wallets.length, " wallet adapters"), 'success');
        wallets.forEach(function (wallet) {
            addLogEntry("Available adapter: ".concat(wallet.adapter.name, " (").concat(getReadyStateLabel(wallet.readyState), ")"), 'info');
        });
    }, [wallets.length, addLogEntry, isMobile, wallets]);
    // Log changes in connection state
    (0, react_1.useEffect)(function () {
        if (connected && wallet) {
            addLogEntry("Connected to wallet with public key: ".concat(publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58()), 'success');
        }
    }, [connected, wallet, publicKey, addLogEntry]);
    // Track previous public key for account changes
    (0, react_1.useEffect)(function () {
        if (publicKey && previousPublicKeyRef.current &&
            publicKey.toBase58() !== previousPublicKeyRef.current.toBase58()) {
            addLogEntry("Account changed from ".concat(previousPublicKeyRef.current.toBase58(), " to ").concat(publicKey.toBase58()), 'warning');
        }
        previousPublicKeyRef.current = publicKey;
    }, [publicKey, addLogEntry]);
    (0, react_1.useEffect)(function () {
        if (!(wallet === null || wallet === void 0 ? void 0 : wallet.adapter))
            return;
        setClickedWalletName(wallet === null || wallet === void 0 ? void 0 : wallet.adapter.name);
        return function () { };
    }, [connected, wallet]);
    // Note: Account is automatically provided by the wallet when connected
    // Account switching happens in wallet extension (e.g., Phantom UI)
    // Helper function to get readable wallet state
    var getReadyStateLabel = function (readyState) {
        switch (readyState) {
            case solana_headless_core_1.WalletReadyState.Installed:
                return 'Installed';
            case solana_headless_core_1.WalletReadyState.Loadable:
                return 'Loadable';
            case solana_headless_core_1.WalletReadyState.NotDetected:
                return 'Not Detected';
            case solana_headless_core_1.WalletReadyState.Unsupported:
                return 'Not Supported';
            default:
                return 'Unknown';
        }
    };
    // Handle wallet selection
    var handleSelectWallet = function (walletName) {
        setClickedWalletName(walletName);
        addLogEntry("Selected wallet: ".concat(walletName), 'info');
    };
    // Connect to wallet
    var handleConnectWallet = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!clickedWalletName) {
                        addLogEntry('No wallet selected', 'warning');
                        return [2 /*return*/];
                    }
                    addLogEntry('Connecting wallet...', 'info');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 6]);
                    return [4 /*yield*/, select(clickedWalletName)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, connect()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    console.error('Connection error:', error_1);
                    addLogEntry("Connection error: ".concat(error_1.message || 'Unknown error'), 'error');
                    return [4 /*yield*/, disconnect()];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Connect and sign message
    var handleConnectSignWallet = function () { return __awaiter(_this, void 0, void 0, function () {
        var statement, result, signature, signatureBase64, error_2, selectedAdapter, isConnected;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!clickedWalletName) {
                        addLogEntry('No wallet selected', 'warning');
                        return [2 /*return*/];
                    }
                    addLogEntry('Connecting wallet and preparing to sign message...', 'info');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 11]);
                    return [4 /*yield*/, select(clickedWalletName)];
                case 2:
                    _a.sent();
                    if (!signIn) return [3 /*break*/, 4];
                    statement = "Test message for wallet authentication at ".concat(new Date().toISOString());
                    return [4 /*yield*/, signIn({ statement: statement })];
                case 3:
                    result = _a.sent();
                    console.log("Sign in Result:", result);
                    signature = result.signature;
                    if (signature) {
                        signatureBase64 = void 0;
                        try {
                            signatureBase64 = btoa(String.fromCharCode.apply(null, Array.from(signature)));
                        }
                        catch (_b) {
                            signatureBase64 = Array.from(signature).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
                        }
                        addLogEntry("Message signed successfully! Signature: ".concat(signatureBase64), 'success');
                    }
                    return [2 /*return*/];
                case 4: return [3 /*break*/, 11];
                case 5:
                    error_2 = _a.sent();
                    addLogEntry('Wallet does not support signIn', 'info');
                    if (!(error_2 == "Error: Wallet does not support sign in")) return [3 /*break*/, 8];
                    return [4 /*yield*/, connect()];
                case 6:
                    selectedAdapter = _a.sent();
                    isConnected = selectedAdapter.connected;
                    if (isConnected) {
                        addLogEntry('Successfully connected to wallet!', 'success');
                    }
                    else {
                        addLogEntry('Connection attempted but wallet reported not connected', 'warning');
                    }
                    return [4 /*yield*/, handleSignMessage(isConnected)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 10];
                case 8:
                    console.error('Connect and sign error:', error_2);
                    addLogEntry("Sign message error: ".concat(error_2.message), 'error');
                    return [4 /*yield*/, disconnect()];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10: return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    // Sign a message
    var handleSignMessage = function (isConnected) { return __awaiter(_this, void 0, void 0, function () {
        var connectStatus, message, messageBytes, signature, signatureBase64, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectStatus = isConnected || connected;
                    if (!connectStatus || !signMessage) {
                        addLogEntry('Wallet not connected or does not support signing', 'error');
                        return [2 /*return*/];
                    }
                    message = "Test message for wallet authentication at ".concat(new Date().toISOString());
                    addLogEntry("Signing message: \"".concat(message, "\""), 'info');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    messageBytes = new TextEncoder().encode(message);
                    return [4 /*yield*/, signMessage(messageBytes)];
                case 2:
                    signature = _a.sent();
                    signatureBase64 = void 0;
                    try {
                        signatureBase64 = btoa(String.fromCharCode.apply(null, Array.from(signature)));
                    }
                    catch (_b) {
                        signatureBase64 = Array.from(signature).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
                    }
                    addLogEntry("Message signed successfully! Signature: ".concat(signatureBase64), 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.error('Sign message error:', error_3);
                    addLogEntry("Sign message error: ".concat(error_3.message), 'error');
                    // Only disconnect on actual connection errors, not user rejections
                    if (!(0, errors_1.isHermisError)(error_3, errors_1.HERMIS_ERROR__WALLET_INTERACTION__USER_REJECTED_SIGNATURE)) {
                        // This is a real error, not a user rejection - might be connection issue
                        // For now, we'll just log it and not disconnect
                        // await disconnect();
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Sign a message using Kit (dual architecture)
    var handleSignMessageKit = function () { return __awaiter(_this, void 0, void 0, function () {
        var message, signer, messageBytes, signature, signatureBase64, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!connected || !(wallet === null || wallet === void 0 ? void 0 : wallet.adapter)) {
                        addLogEntry('Wallet not connected for kit message signing', 'error');
                        return [2 /*return*/];
                    }
                    message = "Test Kit message for wallet authentication at ".concat(new Date().toISOString());
                    addLogEntry("Signing message using Kit (dual architecture): \"".concat(message, "\""), 'info');
                    addLogEntry('Using dual architecture signMessage with connected wallet adapter', 'info');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, (0, kit_1.generateKeyPairSigner)()];
                case 2:
                    signer = _a.sent();
                    messageBytes = new TextEncoder().encode(message);
                    return [4 /*yield*/, (0, solana_headless_react_1.signMessage)(messageBytes, signer)];
                case 3:
                    signature = _a.sent();
                    signatureBase64 = void 0;
                    try {
                        signatureBase64 = btoa(String.fromCharCode.apply(null, Array.from(signature)));
                    }
                    catch (_b) {
                        signatureBase64 = Array.from(signature).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
                    }
                    addLogEntry("Kit message signed successfully! Signature: ".concat(signatureBase64), 'success');
                    addLogEntry('Note: This used the dual architecture approach - same wallet, different code path', 'info');
                    return [3 /*break*/, 5];
                case 4:
                    error_4 = _a.sent();
                    console.error('Kit sign message error:', error_4);
                    addLogEntry("Kit sign message error: ".concat(error_4.message), 'error');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Disconnect wallet
    var handleDisconnectWallet = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    addLogEntry('Disconnecting wallet...', 'info');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, disconnect()];
                case 2:
                    _a.sent();
                    setClickedWalletName(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    console.error('Disconnection error:', error_5);
                    addLogEntry("Disconnection error: ".concat(error_5.message), 'error');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Get wallet balance from the connection directly
    var getBalance = function () { return __awaiter(_this, void 0, void 0, function () {
        var balanceValue, solBalance, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isFetchingBalance || !publicKey)
                        return [2 /*return*/];
                    setIsFetchingBalance(true);
                    addLogEntry('Fetching wallet balance...', 'info');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, connection.getBalance(publicKey)];
                case 2:
                    balanceValue = _a.sent();
                    solBalance = balanceValue / 1000000000;
                    addLogEntry("Balance retrieved: ".concat(solBalance, " SOL"), 'success');
                    return [3 /*break*/, 5];
                case 3:
                    error_6 = _a.sent();
                    console.error('Error getting balance:', error_6);
                    addLogEntry("Error getting balance: ".concat(error_6.message), 'error');
                    return [3 /*break*/, 5];
                case 4:
                    setIsFetchingBalance(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Render wallet adapter details
    var renderAdapterDetails = function () {
        if (!wallet) {
            return (0, jsx_runtime_1.jsx)("p", { children: "No wallet selected" });
        }
        var adapter = wallet.adapter;
        var supportedTransactionsText = adapter.supportedTransactionVersions
            ? Array.from(adapter.supportedTransactionVersions).join(', ')
            : 'Not specified';
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("dl", { children: [(0, jsx_runtime_1.jsx)("dt", { children: "Name:" }), (0, jsx_runtime_1.jsx)("dd", { children: adapter.name }), (0, jsx_runtime_1.jsx)("dt", { children: "Ready State:" }), (0, jsx_runtime_1.jsx)("dd", { children: getReadyStateLabel(adapter.readyState) }), (0, jsx_runtime_1.jsx)("dt", { children: "Connected:" }), (0, jsx_runtime_1.jsx)("dd", { children: adapter.connected ? 'Yes' : 'No' }), (0, jsx_runtime_1.jsx)("dt", { children: "Active Account:" }), (0, jsx_runtime_1.jsx)("dd", { className: "active-account", children: adapter.publicKey ? adapter.publicKey.toBase58() : 'Not available' }), (0, jsx_runtime_1.jsx)("dt", { children: "Account Status:" }), (0, jsx_runtime_1.jsx)("dd", { children: adapter.publicKey ? 'Connected (switch accounts in wallet extension)' : 'Not connected' }), (0, jsx_runtime_1.jsx)("dt", { children: "URL:" }), (0, jsx_runtime_1.jsx)("dd", { children: (0, jsx_runtime_1.jsx)("a", { href: adapter.url, target: "_blank", children: adapter.url || 'Not available' }) }), (0, jsx_runtime_1.jsx)("dt", { children: "Supported Transactions:" }), (0, jsx_runtime_1.jsx)("dd", { children: supportedTransactionsText })] }), (0, jsx_runtime_1.jsxs)("div", { className: "adapter-methods", children: [(0, jsx_runtime_1.jsx)("h3", { children: "Available Methods" }), (0, jsx_runtime_1.jsxs)("ul", { children: ['connect' in adapter ? (0, jsx_runtime_1.jsx)("li", { children: "connect()" }) : null, 'disconnect' in adapter ? (0, jsx_runtime_1.jsx)("li", { children: "disconnect()" }) : null, 'sendTransaction' in adapter ? (0, jsx_runtime_1.jsx)("li", { children: "sendTransaction()" }) : null, 'signAndSendTransaction' in adapter ? (0, jsx_runtime_1.jsx)("li", { children: "signAndSendTransaction()" }) : null, 'signTransaction' in adapter ? (0, jsx_runtime_1.jsx)("li", { children: "signTransaction()" }) : null, 'signAllTransactions' in adapter ? (0, jsx_runtime_1.jsx)("li", { children: "signAllTransactions()" }) : null, 'signMessage' in adapter ? (0, jsx_runtime_1.jsx)("li", { children: "signMessage()" }) : null, 'signIn' in adapter ? (0, jsx_runtime_1.jsx)("li", { children: "signIn()" }) : null] })] })] }));
    };
    // State for controlling the modal
    var _g = (0, react_1.useState)(false), isModalOpen = _g[0], setIsModalOpen = _g[1];
    // Handler for transaction events
    var handleTransactionSent = function (signature) {
        addLogEntry("Transaction sent with signature: ".concat(signature), 'success');
    };
    // Note: Account changes are now detected automatically via wallet events
    // No manual handler needed - see StandardWalletAdapter event listener
    // Handler for dual architecture method results
    // const handleMethodResult = (method: string, _result: string, architecture: string) => {
    //   addLogEntry(` ${method} completed using ${architecture} architecture`, 'success');
    // };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container", children: [(0, jsx_runtime_1.jsxs)("header", { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Solana Headless Wallet Demo" }), (0, jsx_runtime_1.jsx)("p", { className: "subtitle", children: "React implementation using @hermis/solana-headless-react" })] }), (0, jsx_runtime_1.jsx)(NetworkSelector_1.NetworkSelector, { currentNetwork: currentNetwork, onNetworkChange: changeNetwork, disabled: isChangingNetwork || connecting }), (0, jsx_runtime_1.jsxs)("div", { className: "wallet-container ".concat(isMobile ? 'mobile-view' : ''), children: [(0, jsx_runtime_1.jsxs)("div", { className: "wallet-section", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Available Wallets" }), (0, jsx_runtime_1.jsx)("div", { id: "wallet-list", className: "wallet-list", children: wallets.length === 0 ? ((0, jsx_runtime_1.jsx)("p", { className: "empty-message", children: "No wallets found. Please install a Solana wallet." })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [installed.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "wallet-section-header", children: "Installed Wallets" }), installed.map(function (adapter, index) { return ((0, jsx_runtime_1.jsx)(WalletItem, { name: adapter.name.toString(), icon: adapter.icon || '', readyState: adapter.readyState, index: index + 1, isSelected: clickedWalletName === adapter.name.toString(), disabled: false, onClick: function () { return handleSelectWallet(adapter.name.toString()); } }, adapter.name)); })] })), loadable.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "wallet-section-header", children: "Loadable Wallets" }), loadable.map(function (adapter, index) { return ((0, jsx_runtime_1.jsx)(WalletItem, { name: adapter.name.toString(), icon: adapter.icon || '', readyState: adapter.readyState, index: installed.length + index + 1, isSelected: clickedWalletName === adapter.name.toString(), disabled: false, onClick: function () { return handleSelectWallet(adapter.name.toString()); } }, adapter.name)); })] })), notDetected.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "wallet-section-header", children: "Not Detected Wallets" }), notDetected.map(function (adapter, index) { return ((0, jsx_runtime_1.jsx)(WalletItem, { name: adapter.name.toString(), icon: adapter.icon || '', readyState: adapter.readyState, index: installed.length + loadable.length + index + 1, isSelected: clickedWalletName === adapter.name.toString(), disabled: true, onClick: function () { } }, adapter.name)); })] }))] })) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "connection-section", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Wallet Connection" }), isMobile && ((0, jsx_runtime_1.jsx)("div", { className: "mobile-notice", children: "When connecting, you will be redirected to your wallet app. Return to this page after approving the connection." })), (0, jsx_runtime_1.jsxs)("div", { className: "status-container", children: [(0, jsx_runtime_1.jsx)("div", { id: "connection-status", className: "status", children: connected
                                            ? "Connected to: ".concat(wallet === null || wallet === void 0 ? void 0 : wallet.adapter.name)
                                            : clickedWalletName
                                                ? "Selected: ".concat(clickedWalletName, ", Status: Not connected")
                                                : 'Not connected (select a wallet)' }), (0, jsx_runtime_1.jsxs)("div", { id: "wallet-address", className: "address", children: ["Wallet address: ", publicKey ? publicKey.toBase58() : 'Not available'] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "button-group", children: [(0, jsx_runtime_1.jsx)("button", { onClick: handleConnectWallet, disabled: !clickedWalletName || connecting || connected, children: "Connect" }), (0, jsx_runtime_1.jsx)("button", { onClick: handleConnectSignWallet, disabled: !clickedWalletName || connecting || connected || isMobile, style: isMobile ? { display: 'none' } : undefined, children: "Sign In" }), (0, jsx_runtime_1.jsx)("button", { onClick: function () { return setIsModalOpen(true); }, disabled: connecting || connected, children: "Connect with Modal" }), (0, jsx_runtime_1.jsx)("button", { onClick: function () { return handleSignMessage(); }, disabled: !connected || !signMessage, style: { display: connected && signMessage ? 'block' : 'none' }, children: "Sign Message" }), (0, jsx_runtime_1.jsx)("button", { onClick: handleSignMessageKit, disabled: !connected || !(wallet === null || wallet === void 0 ? void 0 : wallet.adapter), style: {
                                            display: connected && (wallet === null || wallet === void 0 ? void 0 : wallet.adapter) ? 'block' : 'none',
                                            backgroundColor: '#4CAF50',
                                            color: 'white'
                                        }, title: "Sign message using Kit dual architecture approach", children: "Sign Message (Kit)" }), (0, jsx_runtime_1.jsx)("button", { onClick: handleDisconnectWallet, disabled: !connected, children: "Disconnect" })] })] }), (0, jsx_runtime_1.jsxs)("div", { id: "wallet-details", className: "wallet-details-section", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Wallet Details" }), (0, jsx_runtime_1.jsx)("div", { className: "details-container", children: (0, jsx_runtime_1.jsx)("div", { id: "selected-adapter-info", children: renderAdapterDetails() }) })] }), (0, jsx_runtime_1.jsxs)("div", { id: "transaction-actions", className: "transaction-section", style: { display: connected ? 'block' : 'none' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "Actions" }), (0, jsx_runtime_1.jsxs)("div", { className: "action-buttons", children: [(0, jsx_runtime_1.jsx)("button", { id: "get-balance-button", onClick: getBalance, disabled: isFetchingBalance || !publicKey, children: "Get Balance" }), (0, jsx_runtime_1.jsx)("div", { id: "balance-display", className: "balance ".concat(isFetchingBalance ? 'loading' : ''), children: isFetchingBalance
                                            ? 'Fetching balance...'
                                            : balance.balance !== null
                                                ? "Balance: ".concat(balance.balance.toLocaleString(), " SOL")
                                                : '' })] })] })] }), connected && ((0, jsx_runtime_1.jsxs)("div", { className: "extended-components", children: [(0, jsx_runtime_1.jsx)("div", { className: "component-row", children: (0, jsx_runtime_1.jsx)(TransactionCard_1.TransactionCard, { onTransactionSent: handleTransactionSent }) }), (0, jsx_runtime_1.jsxs)("div", { className: "component-row token-components", children: [(0, jsx_runtime_1.jsx)("div", { className: "component-column", children: (0, jsx_runtime_1.jsx)(TokenBalances_1.TokenBalances, {}) }), (0, jsx_runtime_1.jsx)("div", { className: "component-column", children: (0, jsx_runtime_1.jsx)(NFTGallery_1.NFTGallery, {}) })] })] })), (0, jsx_runtime_1.jsxs)("div", { id: "log-container", className: "log-section", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Event Log" }), (0, jsx_runtime_1.jsx)("div", { id: "event-log", className: "event-log", ref: eventLogRef, children: eventLogs.map(function (log, index) { return ((0, jsx_runtime_1.jsxs)("div", { className: "log-entry log-type-".concat(log.type), children: [(0, jsx_runtime_1.jsxs)("span", { className: "log-timestamp", children: ["[", log.timestamp.toLocaleTimeString(), "]"] }), " ", log.message] }, index)); }) }), (0, jsx_runtime_1.jsx)("button", { id: "clear-log-button", onClick: clearLogs, children: "Clear Log" })] }), (0, jsx_runtime_1.jsx)(WalletModal_1.WalletModal, { isOpen: isModalOpen, onClose: function () { return setIsModalOpen(false); } })] }));
}
exports.default = App;
